import { render, staticRenderFns } from "./GridSchedule.vue?vue&type=template&id=237a807f&scoped=true&"
import script from "./GridSchedule.ts?vue&type=script&lang=ts&"
export * from "./GridSchedule.ts?vue&type=script&lang=ts&"
import style0 from "./GridSchedule.vue?vue&type=style&index=0&id=237a807f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a807f",
  null
  
)

export default component.exports